import { render, staticRenderFns } from "./PromotionSet.vue?vue&type=template&id=74da31b5&scoped=true"
import script from "./PromotionSet.vue?vue&type=script&lang=js"
export * from "./PromotionSet.vue?vue&type=script&lang=js"
import style0 from "./PromotionSet.vue?vue&type=style&index=0&id=74da31b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da31b5",
  null
  
)

export default component.exports